import NoteTemplateRevisionForm from '~/components/maud/patients/note/NoteTemplateRevisionForm';
import { ChakraBox } from '@equip.health/ui';
import useIntersectionObserver from '~/lib/hooks/useIntersectionObserver';
import { useLatestNoteTemplateRevisionsWithLegacyHandling } from '~/components/maud/patients/note/useLatestNoteTemplateRevisionsWithLegacyHandling';

interface PatientNoteItemTemplateRevisionProps {
  minHeight?: string;
  noteId: string;
  noteTemplateRevisionId: string;
  noteTemplateRevisionData: unknown | undefined;
}

export const PatientNoteItemTemplateRevisionForm = ({
  minHeight = '400px',
  noteId,
  noteTemplateRevisionId,
  noteTemplateRevisionData,
}: PatientNoteItemTemplateRevisionProps) => {
  const { visibleRef, isVisible } = useIntersectionObserver();
  const { isRevisionDataLoading, selectedRevision } =
    useLatestNoteTemplateRevisionsWithLegacyHandling(
      noteTemplateRevisionId,
      !isVisible,
    );

  return (
    <ChakraBox
      data-testid={`patient-note-item-template-revision-${noteId}`}
      minHeight={minHeight}
      ref={visibleRef}
    >
      {isVisible && !isRevisionDataLoading && selectedRevision && (
        <NoteTemplateRevisionForm
          isReadOnly
          noteId={noteId}
          noteTemplateRevisionData={noteTemplateRevisionData}
          noteTemplateRevisionSchema={selectedRevision.templateJson}
        />
      )}
    </ChakraBox>
  );
};
